/* eslint-disable react-hooks/exhaustive-deps */

import React from 'react';
import {connect} from 'react-redux';
import {getLighterShade} from '../colorUtils';

const UploadOtherIds = ({widgets: {widgetPages, widgetScreen, singleApp}}) => {
  const baseColor = singleApp?.color || singleApp?.color_code || '#3f7cdb';
  const lighterShade = getLighterShade(baseColor, 90);

  const widgetData =
    widgetPages &&
    widgetPages?.find(
      widget =>
        widget?.page === 'additional-document' &&
        widget?.pageId === widgetScreen?.pageId,
    );

  const lighterBackgroundStyle = {
    backgroundColor: lighterShade,
  };

  const textColor = {
    color: baseColor,
  };

  return (
    <>
      {/* <div
        className="mx-auto w-fit px-2 pt-2 rounded-[10px] mb-4 text-center"
        style={lighterBackgroundStyle}
      >
        <span
          className="text-sm font-medium inline-flex items-center  "
          style={textColor}
        >
          <InfoIcon backgroundColor={baseColor} />
          To continue this on your smartphone.
          <span className="font-semibold ml-[2px]">Click here</span>
        </span>
      </div> */}

      {/* <header className="flex flex-col items-center mt-3">
        <img src={singleApp?.logo || ''} alt="" className="max-h-10" />
      </header> */}

      <div className="mt-9 px-6 overflow-y-auto max-w-sm w-full">
        <p className="text-center text-base font-medium mt-4 text-[#1B2A4E] mb-4">
          Upload Document
        </p>

        <div className="h-[219px] border border-dashed rounded-[4px] border-brandBlue bg-customWhite flex items-center justify-center">
          <input
            type="file"
            id="file-upload"
            accept="image/jpeg, image/png, image/jpg, .pdf"
            className="hidden"
          />
          <p
            htmlFor="file-upload"
            className="text-sm text-center max-w-[160px]"
          >
            <span className="text-brandBlue cursor-pointer">
              {' '}
              Click here to select
            </span>{' '}
            from your device.
          </p>{' '}
        </div>
      </div>

      {/* <div className="w-full flex flex-col justify-center items-center ">
        <p className="mt-10 text-center text-body text-sm max-w-[326px]">
          {widgetData?.config?.instruction}
        </p>
        {customButton}
      </div> */}

      <div className="flex flex-col mt-4 px-6 justify-center items-center w-full max-w-sm gap-2">
        <button
          // style={buttonStyle}
          className="text-small !text-white font-medium h-12 rounded-lg w-full !bg-brandBlue"
          disabled
        >
          Upload
        </button>
        <button
          className="text-small !text-black rounded-lg font-medium h-12 bg-[#F9F9F9] w-full border border-[#333442]"
          disabled
        >
          <span>Capture Instead</span>
        </button>
      </div>
    </>
  );
};

export default connect(state => state, null)(UploadOtherIds);
